import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

const baseFont = {
  ...hoverBaseStyles.textRegular,
}

export const packagesStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,

    '&:last-of-type': {
      mb: 0,
    },
  } as SxProps<Theme>,

  label: {
    ...baseFont,
    color: 'info.main',
  } as SxProps<Theme>,

  membershipValue: {
    ...baseFont,
    color: 'gray.64',
  } as SxProps<Theme>,

  creditsValue: {
    ...hoverBaseStyles.textSemiBold,
    color: 'gray.64',
  } as SxProps<Theme>,

  bulletWrapper: {
    display: 'flex',
    gap: 0.75,
    alignItems: 'center',
  } as SxProps<Theme>,

  bullet: {
    typography: 'large',
    lineHeight: 1,
    color: 'gray.56',
  } as SxProps<Theme>,
}
